import React from "react";
import history from "../../utils/history";

const PractitionerItem = ({
  image,
  name,
  description,
  profileLink,
  consulatationLink,
  id,
}) => {
  return (
    <div className="prac-item">
      <div className="desc-section">
        <div>
          <div className="round-image-container">
            <img src={image} alt="img" className="round-image" />
          </div>
        </div>
        <div>
          <h2>{name}</h2>
          <p>{description}</p>
        </div>
      </div>
      <div className="button-section">
        <button
          className="btn white-btn"
          //onClick={() => window.open(consulatationLink, "_self")}
          onClick={() => history.push("/appointment", { id, name })}
        >
          Request a consultation
        </button>
        <button
          className="btn btn-orange"
          onClick={() => history.push(profileLink)}
        >
          View profile
        </button>
      </div>
    </div>
  );
};

export default PractitionerItem;
